import { render, staticRenderFns } from "./AppMobilepath.vue?vue&type=template&id=36f6c51e&scoped=true&"
import script from "./AppMobilepath.vue?vue&type=script&lang=js&"
export * from "./AppMobilepath.vue?vue&type=script&lang=js&"
import style0 from "./AppMobilepath.vue?vue&type=style&index=0&id=36f6c51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6c51e",
  null
  
)

export default component.exports